<template>
  <section class="about__video container">
    <div class="about__video-img text-center">
      <img
        src="../../assets/images/home/about-video.png"
        alt="video icon"
        width=""
        height=""
        class="img-fluid"
      />
      <span class="about__video-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="97"
          height="97"
          viewBox="0 0 97 97"
          fill="none"
        >
          <circle cx="48.1732" cy="48.1732" r="48.1732" fill="white" />
          <path
            d="M60.418 46.441C61.7513 47.2108 61.7513 49.1353 60.418 49.9051L43.553 59.6421C42.2196 60.4119 40.553 59.4496 40.553 57.91L40.553 38.436C40.553 36.8964 42.2196 35.9342 43.553 36.704L60.418 46.441Z"
            fill="#062B3B"
          />
        </svg>
      </span>
    </div>
  </section>
</template>
<script></script>
